import { injector } from "@cervval.js/common/src/dependencies/injector";

/** Object of HourGlassService */
export interface HourglassServiceOptions<CustomData> {

    /** Message of loading */
    message?: string;

    /** Progress of loading */
    progress?: number;

    /** Show progress in loading div */
    displayProgress?: boolean;

    /** Data of HourGlass */
    data?: CustomData;

    /** HourGlass will be added in given div */
    parent?: HTMLElement;

    /** 
     * HourGlass will be shown only if process lasts at least showOnlyAfterMs milliseconds 
     * when used within encapsulate, you are expected to pass doNotWait option
     */
    showOnlyIfLongerThanMs?: number;

    /** If set to true, hourglass show will not disbale events */
    doNotDisableEvents?: boolean;
}

/** HourGlassService key */
export const HOURGLASS_SERVICE = "HourglassService";

/**
 * Display "Hourglass" while user is waiting for a reply
 * @packageDocumentation
 * @module HourglassService
 */
export interface HourglassService<CustomData> {

    /** Show loading */
    show(options?: HourglassServiceOptions<CustomData>): number;

    /**
     * Update loading
     * Can be:
     * - Progress counter
     * - Data
     * - Message displayed
     */
    update(id: number, options?: HourglassServiceOptions<CustomData>): void;

    /** Hide loading */
    hide(id: number): void;

    /** Reset loading */
    reset(): void;

    /** Show loading, compute and hide loading */
    encapsulate<T>(compute: (hourGlassId: number) => T | Promise<T>, options?: HourglassServiceOptions<CustomData> & { doNotWait?: boolean }): Promise<T>;

}

/**
 * getHourGlassService from injector, and throws an error if dependency was not found
 */
export function getHourGlassService<CustomData = void>(): HourglassService<CustomData> {
    const hourGlassService = injector.get<HourglassService<CustomData>>(HOURGLASS_SERVICE);
    return hourGlassService;
}